import React from 'react';
import { Text } from '@fluentui/react';
import { mergeStyleSets, getTheme } from '@fluentui/react/lib/Styling';

interface FormFieldProps {
  label: string;
  children: React.ReactNode;
}

const theme = getTheme();

const classNames = mergeStyleSets({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
    padding: '8px 0',
  },
  label: {
    fontSize: 12,
    fontWeight: 400,
    color: theme.palette.neutralSecondary,
    lineHeight: '16px',
  },
  value: {
    fontSize: 14,
    color: theme.semanticColors.bodyText,
    lineHeight: '20px',
  },
});

export default function FormField({ label, children }: FormFieldProps) {
  return (
    <div className={classNames.root}>
      <Text className={classNames.label}>{label}</Text>
      <div className={classNames.value}>{children}</div>
    </div>
  );
}
